/**
 * Returns the `exp` claim (Unix seconds) from a JWT, or null for non-JWTs
 * or malformed tokens. Used by SessionProvider to schedule proactive refresh
 * before expiry — see #2570.
 *
 * Why this exists: the auth client stores access tokens as opaque strings.
 * Most are JWTs, but the legacy hex session token format also flows through
 * the same storage. This helper returns null for the legacy case so callers
 * can fall back gracefully.
 */
export function readJwtExpSeconds(token: string): number | null {
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const payload = parts[1];
    // base64url → base64 (+/= padding)
    const b64 = payload.replace(/-/g, '+').replace(/_/g, '/').padEnd(
      payload.length + ((4 - (payload.length % 4)) % 4),
      '=',
    );
    const json = typeof atob !== 'undefined'
      ? atob(b64)
      : Buffer.from(b64, 'base64').toString('binary');
    const claims = JSON.parse(json) as { exp?: unknown };
    return typeof claims.exp === 'number' ? claims.exp : null;
  } catch {
    return null;
  }
}
